$(function () {
    
    $('#form-contact').find('input, textarea').bind("change paste keydown", function() {
        $(this).parent().removeClass('form__field--success');
        $(this).parent().removeClass('form__field--error');
        $('#form-contact .form__field__submit').prop("disabled", false);
    });

    $('#form-contact').submit(function (event) {
        event.preventDefault();

        $('#notification-contact').html('');
        $('#notification-contact').removeClass('alerts--error');
        $('#notification-contact').removeClass('alerts--success');

        $.ajax({
            url: $(this).attr('action'),
            type: "POST",
            data: new FormData(this),
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function (response) {
                if (response.status === "success") {

                    var element = document.getElementById('notification-contact');
                    var offset = 100;
                    var bodyRect = document.body.getBoundingClientRect().top;
                    var elementRect = element.getBoundingClientRect().top;
                    var elementPosition = elementRect - bodyRect;
                    var offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });

                    $('#notification-contact').html('Votre demande a bien été envoyée, nous allons revenir vers vous dans les plus brefs délais.').addClass('alerts--success');
                    $('#form-contact').find('.form__field:not(".form__field--right")').each(function() {
                        $(this).addClass('form__field--success');
                    });

                    $('#form-contact .form__field__submit').prop("disabled", true);

                } else if (response.status === "error") {

                    var element = document.getElementById('notification-contact');
                    var offset = 100;
                    var bodyRect = document.body.getBoundingClientRect().top;
                    var elementRect = element.getBoundingClientRect().top;
                    var elementPosition = elementRect - bodyRect;
                    var offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });

                    if (response.reason === "lastname") {
                        $('#notification-contact').html("Votre demande n'a pas pu être envoyé car le nom indiqué n'est pas valide.").addClass('alerts--error');
                        $('#input-name').parent().addClass('form__field--error');
                    } else if (response.reason === "firstname") {
                        $('#notification-contact').html("Votre demande n'a pas pu être envoyé car le prénom indiqué n'est pas valide.").addClass('alerts--error');
                        $('#input-firstname').parent().addClass('form__field--error');
                    } else if (response.reason === "email") {
                        $('#notification-contact').html("Vous devez indiquer une adresse email valide pour que nous puissions vous répondre.").addClass('alerts--error');
                        $('#input-email').parent().addClass('form__field--error');
                    } else if (response.reason === "telephone") {
                        $('#notification-contact').html("Votre demande n'a pas pu être envoyé car le téléphone indiqué n'est pas valide.").addClass('alerts--error');
                        $('#input-telephone').parent().addClass('form__field--error');
                    } else if (response.reason === "message") {
                        $('#notification-contact').html("Merci d'être plus explicite dans votre demande (minimum 20 caractères).").addClass('alerts--error');
                        $('#textarea-message').parent().addClass('form__field--error');
                    } else {
                        $('#notification-contact').html("Votre demande n'a pu être envoyé, veuillez rééssayer.").addClass('alerts--error');
                    }

                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr);
                console.log(ajaxOptions);
                console.log(thrownError);
            }
        });
    });

});
